<script>

import Endpoints from '../../components/common/Endpoints';
import Common from '../../components/common/Common';
import Request from '../../components/common/Request';
import { mapActions } from 'vuex';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        el.classList.add('authentication-page');
        el.classList.add('authentication-bg');
        el.classList.add('authentication-bg-pattern');
        $('.modal').modal('hide');
        window.location.href = "?#";
    },
    methods:{
        submit: function(){
            this.errors = [];
            this.messageIdToast = null;
            Request.do(this, 'POST', Request.getDefaultHeader(this), this.data, `${Endpoints.systemUsers.login}`,
                async (dataResponse, fullResponse)=>{//SUCCESS CALLBACK
                    if (dataResponse.result.type == "USER-COMPANY"){
                        this.$session.destroy();
                        this.$session.start();
                        this.$session.set('user', dataResponse.result);
                        this.$session.set('token', dataResponse.token);
                        this.$session.set('correlationId', fullResponse.headers['x-correlation-id']);
                        this.user = this.$session.get('user');
                        let response = (await Request.do(this, 'GET', Request.getDefaultHeader(this), {}, `${Endpoints.companies.workhours.getByCompany}`)).data;
                        if (response && response.status==200 && response.result.monStart){
                            if(this.isAdminMaster()){
                                console.log(response.result);
                                this.$router.push({ path: '/list-orders' });
                                window.location.href = "?#/list-orders";
                            }
                            else{
                                    this.$router.push({ path: '/dashboard' });
                                    window.location.href = "?#/dashboard";        
                            }
                        }else{
                            this.$router.push({ path: '/work-hours' });
                            window.location.href = "?#/work-hours";
                        }
                        location.reload();
                    }else{
                        this.titleToast = this.$t("string.msg.warning");
                        this.messageToast = this.$t("string.msg.login.error.not.authorized");
                        $('#toast').modal('show');
                    }
                },
                (error)=>{//ERROR CALLBACK
                    let res = error.response;
                    if (res && res.status != 200){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.user.password.incorrect'){
                            this.messageToast = this.$t(res.data.messageId);
                        }else{
                            this.messageToast = this.$t('response.user.password.incorrect');
                            this.messageIdToast = res.data.messageId;
                        }
                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
        hasType: function(type){
            if (this.user){
                return this.user.companyUser.company.typeService.findIndex(x => x == type) > -1;
            }else{
                return false;
            }
            
        },
        isAdminMaster: function(){
            if (this.user){
                return this.user.companyUser && this.user.companyUser.subtype === "ADMIN_MASTER";
            }
            return false;
        },
        register: function(){
            this.$router.push({ path: '/companies' });
        },
        submitForgotPassword: function(){
            this.errors = [];
            this.messageIdToast = null;
            Request.do(this, 'POST', Request.getDefaultHeader(this), this.data, `${Endpoints.systemUsers.gencode}`,
                (userResponse)=>{//SUCCESS CALLBACK
                    this.data.systemUser = userResponse.result.systemUser;
                    $('#modalEsqueciSenha').modal('show');
                },
                (error)=>{//ERROR CALLBACK
                    let res = error.response;
                    console.log(!res.status == 200);
                    if (res && res.status != 200){
                        this.titleToast = "Aviso";
                        
                        this.messageToast = this.$t('string.msg.change.password.email.invalid');

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(res));
            });
        },
        checkForgotPassword: function(){
            this.errors = [];
            this.messageIdToast = null;
            if (!this.data.email){
                this.titleToast = "Aviso";
                this.messageToast = this.$t('string.msg.change.password.label.email.required');

                $('#toast').modal('show');
                return;
            }else{
                this.submitForgotPassword();
            }
        },
        checkCode: function(){
            this.errors = [];
            this.messageIdToast = null;
            if (!this.data.code){
                this.errors.push(this.$t('string.login.forgot.password.id.required'));
            }else {
                Request.do(this, 'POST', Request.getDefaultHeader(this), this.data, `${Endpoints.systemUsers.checkCode}`,
                    (userResponse)=>{//SUCCESS CALLBACK
                        this.$session.destroy();
                        this.$session.start();
                        this.$session.set('code', this.data.code);

                        $('.modal').modal('hide');
                        $('#modalReset').modal('show');
                    },
                    (error)=>{//ERROR CALLBACK
                        let res = error.response;
                        if (res && res.status == 500){
                            this.errors = [];
                            if (res.data.messageId === 'string.user.code.incorrect'){
                                this.errors.push(this.$t(res.data.messageId));
                            }else{
                                this.errors.push(this.$t('string.user.code.incorrect'));
                            }
                        }
                });
            }
        },
        resetPass: function(){
            this.errors = [];
            this.messageIdToast = null;
            if (!this.data.password || this.data.password != this.data.passwordConfirm || this.data.password.length < 7){
                this.errors.push(this.$t('string.company.admin.register.password.required'));
            }else {
                let params = {
                    code: this.$session.get('code'),
                    systemUser: this.data.systemUser,
                    password: this.data.password
                }
                Request.do(this, 'POST', Request.getDefaultHeader(this), params, `${Endpoints.systemUsers.resetPassNotLog}`,
                    (userResponse)=>{//SUCCESS CALLBACK
                        $('.modal').modal('hide');

                        this.titleToast = "Aviso";
                        this.messageToast = this.$t('string.login.reset.password.success');
                        $('#toast').modal('show');
                    },
                    (error)=>{//ERROR CALLBACK
                        let res = error.response;
                        if (res && res.status == 500){
                            this.errors = [];
                            if (res.data.messageId === 'string.user.code.incorrect'){
                                this.errors.push(this.$t(res.data.messageId));
                            }else{
                                this.errors.push(this.$t('string.msg.error.generic'));
                            }
                        }
                });
            }
        }
       
    }
}
</script>
